import { Component } from "react";
import { connect } from "react-redux";
import ApplicationTableItem from "./ApplicationTableItem";
import axios from "axios";
import urls from "../urls";
import _ from "lodash";
import formatDateArabicDZ from "../utils/formatDate";
import { setInitialOrderItems } from "../redux-state/features/orderState";
class ApplicationTable extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      table_data: [],
      isTableLoading: true,
    };
    this.headerText = [
      "#",
      "المستخدم ",
      "البريد الإلكتروني",
      "نوع الطلب",
      "التاريخ ",
      "الحالة",
    ];
  }
  componentDidMount() {
    const { faculty_id } = JSON.parse(localStorage.getItem("user"));
    axios
      .get(urls.getAllOrders(faculty_id))
      .then((res) => {
        const data = _.map(res.data, (obj) => ({
          email: obj.email,
          user: obj.full_name,
          applicationType: "order",
          date: formatDateArabicDZ(obj.order_date),
          status: obj.order_status,
          orderId: obj.order_id,
          userId: obj.user_id,
          userType: obj.user_type,
          orderItems: obj.order_details,
        }));
        this.props.setInitialOrderItems(data);

        axios
          .get(urls.getAllServices, {
            params: {
              faculty_id,
            },
          })
          .then((res) => {
            const data = _.map(res.data, (obj) => {
              return {
                ...obj,
                date: formatDateArabicDZ(obj.request_date),
                applicationType: "service",
              };
            });
            this.props.setInitialOrderItems(data);
            this.setState({ isTableLoading: false });
          });
      })
      .catch((err) => console.log(err))
      .finally(() => {
        this.setState({ isTableLoading: false });
      });
  }
  render() {
    const obj = {
      email: "gtf@gmail.com",
      user: "Gattaf Khaled",
      applicationType: "service",
      date: new Date().toLocaleDateString(),
      status: "Pending",
      orderId: "123456",
    };
    const { table_data } = this.props;
    const { isTableLoading } = this.state;
    return (
      <div>
        <table className="table align-middle">
          <thead className="table-light text-center">
            <tr style={{ fontSize: "12px" }}>
              {this.headerText.map((txt, idx) => (
                <th key={"app-header" + idx}>{txt}</th>
              ))}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {isTableLoading ? (
              <tr>
                <td colSpan={6} className="text-center">
                  <div
                    className="spinner-border text-primary"
                    style={{ width: "3rem", height: "3rem" }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            ) : (
              table_data.map((obj, idx) => (
                <ApplicationTableItem
                  orderNumber={idx + 1}
                  key={"ApplicationTableItem-" + idx}
                  obj={obj}
                />
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapDispatchToProps = { setInitialOrderItems };
const mapStateToProps = (state) => ({
  table_data: state.orderState.orderData,
});
export default connect(mapStateToProps, mapDispatchToProps)(ApplicationTable);
